import { useEffect, useRef } from "react";
export const useResizeObserver = (target, callback) => {
    const callbackRef = useRef(callback);
    useEffect(() => {
        callbackRef.current = callback;
    });
    useEffect(() => {
        if (!target.current) {
            return;
        }
        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                callbackRef.current(entry.contentRect);
            }
        });
        observer.observe(target.current);
        return () => {
            observer.disconnect();
        };
    }, [target]);
};
